import React from 'react';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section className="hero" data-id="element-122">
      <div className="eyebrow mb-6" data-id="element-123">
        <span data-id="element-124">Yetu Design Lab</span>
      </div>
      <h1 data-id="element-125">
        We design brands that people <span className="serif" data-id="element-126">remember.</span>
      </h1>
      <p className="sub" data-id="element-127">
        Yetu is a Nairobi studio building brand identities, websites, and
        campaigns for teams who'd rather stand out than blend in.
      </p>
      <div className="actions" data-id="element-128">
        <CtaButton to="/#contact" variant="pill" data-id="element-129">
          Book Free Consultation
        </CtaButton>
        <CtaButton to="/#work" variant="ghost" data-id="element-130">
          View our work
        </CtaButton>
      </div>

      <div className="logos" data-id="element-131">
        <div className="cap" data-id="element-132">
          Trusted by teams building in East Africa & beyond
        </div>
        <div className="row" data-id="element-133">
          <div className="clogo" data-id="element-134">
            <span className="dot" data-id="element-135"></span>Taartu
          </div>
          <div className="clogo" data-id="element-136">
            <span className="dot" data-id="element-137"></span>Flow Key
          </div>
          <div className="clogo" data-id="element-138">
            <span className="dot" data-id="element-139"></span>Nova Cloud
          </div>
          <div className="clogo" data-id="element-140">
            <span className="dot" data-id="element-141"></span>TendePay
          </div>
          <div className="clogo" data-id="element-142">
            <span className="dot" data-id="element-143"></span>Skybistro
          </div>
          <div className="clogo" data-id="element-144">
            <span className="dot" data-id="element-145"></span>PixelPaints
          </div>
        </div>
      </div>
    </section>;
}